export const MAX_PERCENTAGE_DECIMALS = 2;
export const PERCENTAGE_FACTOR = 10 ** MAX_PERCENTAGE_DECIMALS;
export const MIN_VALUE = 10 ** -MAX_PERCENTAGE_DECIMALS;
